import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMusicAudio = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.2255 2.92C19.3993 3.06245 19.5 3.27531 19.5 3.50001V6.98613C19.5002 6.99595 19.5002 7.00575 19.5 7.01551V16C19.5 17.7949 18.0449 19.25 16.25 19.25C14.4551 19.25 13 17.7949 13 16C13 14.2051 14.4551 12.75 16.25 12.75C16.8943 12.75 17.4949 12.9375 18 13.2609V7.91488L10.5049 9.4139C9.92057 9.53076 9.5 10.0438 9.5 10.6396V18C9.5 19.7949 8.04493 21.25 6.25 21.25C4.45507 21.25 3 19.7949 3 18C3 16.2051 4.45507 14.75 6.25 14.75C6.89432 14.75 7.49485 14.9375 8 15.2609V7.13961C8 5.82874 8.92526 4.7001 10.2107 4.44302L18.6029 2.76457C18.8232 2.7205 19.0517 2.77755 19.2255 2.92ZM9.5 8.18977C9.72019 8.07745 9.9585 7.99347 10.2107 7.94303L18 6.38517V4.41486L10.5049 5.91389C9.92057 6.03074 9.5 6.54376 9.5 7.13961V8.18977ZM16.25 14.25C17.2165 14.25 18 15.0335 18 16C18 16.9665 17.2165 17.75 16.25 17.75C15.2835 17.75 14.5 16.9665 14.5 16C14.5 15.0335 15.2835 14.25 16.25 14.25ZM6.25 16.25C7.2165 16.25 8 17.0335 8 18C8 18.9665 7.2165 19.75 6.25 19.75C5.2835 19.75 4.5 18.9665 4.5 18C4.5 17.0335 5.2835 16.25 6.25 16.25Z",
		fill: "currentColor"
	})
});
export { SvgIconMusicAudio as ReactComponent };
